import * as lodash from 'lodash/fp';
import { defineModule, localActionContext } from "direct-vuex"

import * as InternalUser from "@/lib/Util/Types/InternalUser/InternalUser";
import * as REST from '@/lib/Util/REST'
import { RootState } from '@/store/Shared'

const state = {
    value: null as InternalUser.T | null,
    message: REST.getEmpty()
}

const mutations = {
    updateValue(state: State, v: InternalUser.T | null) {
        state.value = v;
    },
    updateMsg(state: State, v: REST.RestMessage) {
        state.message = v
    },
}


export function migrate(token?: string) {
    const req = {
        token: token ?? "NO TOKEN",
        url: "/compragauser/migrate",
        payload: {},
        transformer: function (v: any) { console.log("TRANSFORM:", v); return null }
    };
    return REST.GET(state.message, req);
}

async function saving(context: any, url: string, x: InternalUser.T) {
    /* eslint-disable @typescript-eslint/no-use-before-define */
    const { commit, state } = actionCtx(context)
    const rootState = context.rootState as RootState
    try {
        const loading_msg = {
            ...state.message,
            loading: true
        }
        commit.updateMsg(loading_msg)

        const req = {
            token: rootState.authentication?.token ?? "NO TOKEN",
            url,
            payload: x,
            transformer: InternalUser.tryParse
        };
        const result = await REST.POST(state.message, req);
        const msg = {
            ...lodash.cloneDeep(result.msg),
            text: `Successfully saved user: ${x.email.Value}`
        }
        commit.updateValue(result.value)
        commit.updateMsg(msg)
    }
    catch (ex) {
        const msg = {
            ...lodash.cloneDeep(state.message),
            text: JSON.stringify(ex)
        }
        commit.updateMsg(msg)
    }
}

async function loading(context: any, url: string) {
    /* eslint-disable @typescript-eslint/no-use-before-define */
    const { commit, state } = actionCtx(context)
    const rootState = context.rootState as RootState
    try {
        const loading_msg = {
            ...state.message,
            loading: true
        }
        commit.updateMsg(loading_msg)
        const req = {
            token: rootState.authentication?.token ?? "NO TOKEN",
            url,
            payload: {},
            transformer: InternalUser.tryParse
        };
        const result = await REST.GET(state.message, req);
        const msg = {
            ...lodash.cloneDeep(result.msg),
            text: `Successfully loaded user ${result.value?.email.Value}`
        }
        commit.updateValue(result.value)
        commit.updateMsg(msg)
    }
    catch (ex) {
        const msg = {
            ...lodash.cloneDeep(state.message),
            text: JSON.stringify(ex)
        }
        commit.updateMsg(msg)
    }
}

const actions = {
    async LOAD(context: any, x: string) {
        loading(context, `/compragauser/${x}`)
    },
    async SAVE(context: any, x: InternalUser.T) {
        if (x.id) {
            saving(context, `/compragauser/${x.id}/update`, x)
            return
        }
        else {
            saving(context, `/compragauser/create`, x)
            return
        }
    },
    async TOGGLE(context: any, x: string) {
        loading(context, `/compragauser/${x}/activate`)
    },
}

export const internal = {
    namespaced: true as const,
    state,
    mutations,
    actions,
}

export type Mutations = typeof mutations
export type State = typeof state
export type Actions = typeof actions

export const module = defineModule(internal)

export default module

const actionCtx = (context: any) => localActionContext(context, module)
